(function () {
  function initializeDealerApplication(form) {
    var successPanel = form.querySelector('[data-dealer-application-success]');
    var formFields = form.querySelector('[data-dealer-application-fields]');
    var submitButton = form.querySelector('[data-dealer-application-submit]');
    var submitLabel = form.querySelector('[data-dealer-application-submit-label]');
    var submittedSuccessfully = new URLSearchParams(window.location.search).get('contact_posted') === 'true';

    if (submittedSuccessfully && successPanel && formFields) {
      successPanel.hidden = false;
      formFields.hidden = true;
      if (window.StarlightTracking) {
        window.StarlightTracking.once(
          'starlight:dealer_application_submitted',
          { form_name: 'dealer_application' },
          window.location.pathname + ':dealer_application'
        );
      }
      window.requestAnimationFrame(function () {
        successPanel.focus({ preventScroll: true });
      });
      return;
    }

    form.addEventListener('submit', function () {
      if (!submitButton) return;
      submitButton.disabled = true;
      submitButton.setAttribute('aria-busy', 'true');
      if (submitLabel) submitLabel.textContent = 'Submitting application...';
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-dealer-application-form]').forEach(initializeDealerApplication);
  });
})();
